function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4d4d4d;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.545-12.056c-1.05.816-2.437,1.856-7.219,5.33C15.375-6.033,13.673-4.481,12-4.5,10.336-4.486,8.667-6,7.678-6.727,2.9-10.2,1.5-11.236.455-12.052a.28.28,0,0,0-.455.22V-2.25A2.251,2.251,0,0,0,2.25,0h19.5A2.251,2.251,0,0,0,24-2.25v-9.586A.282.282,0,0,0,23.545-12.056ZM12-6c1.088.019,2.653-1.369,3.441-1.941,6.22-4.514,6.694-4.908,8.128-6.033A1.122,1.122,0,0,0,24-14.859v-.891A2.251,2.251,0,0,0,21.75-18H2.25A2.251,2.251,0,0,0,0-15.75v.891a1.129,1.129,0,0,0,.431.886c1.434,1.12,1.908,1.519,8.128,6.033C9.347-7.369,10.912-5.981,12-6Z",
  transform: "translate(0 18)"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.ac13140d.svg";
export { ForwardRef as ReactComponent };